import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ProgramItem } from './program-item.model';

export class ProgramItemStateModel extends EntityStateModel<ProgramItem> {}
